import React from "react";

import "./UnderlinedTitle.scss";

export const UnderlinedTitle: React.FC = React.memo(({ children }) => {
  return <div className="underlined-title">{children}</div>;
});
